import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Overlay } from '@angular/cdk/overlay';
export function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, './assets/i18n/', // or whatever path you're using
    '.json');
}
export function scrollFactory(overlay) {
    return function () { return overlay.scrollStrategies.close(); };
}
var AddOccurenceModalModule = /** @class */ (function () {
    function AddOccurenceModalModule() {
    }
    return AddOccurenceModalModule;
}());
export { AddOccurenceModalModule };
